export default function ContactSection() {
  return (
    <section id="contact" className="bg-[#0c0e12] py-20 px-8">
      <div className="max-w-7xl mx-auto">
        {/* Top row */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 pb-14 border-b border-white/10">
          {/* Left: Brand */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <img
                  src="https://public.readdy.ai/ai/img_res/6e2b7356-853f-4ffe-b902-66898a5bfd06.png"
                  alt="IDEA D.O.O. Logo"
                  className="w-12 h-12 object-contain"
                />
              </div>
              <span className="text-white font-bold text-xl tracking-wide">IDEA D.O.O.</span>
            </div>
            <p className="text-white/50 text-base leading-relaxed max-w-sm">
              A team of experts developing modern applications for the iOS platform.
              Our products are designed to enhance user experience and improve the security
              of mobile devices.
            </p>
            <div className="flex gap-4 mt-8">
              {['ri-apple-fill', 'ri-shield-fill', 'ri-smartphone-fill'].map((icon) => (
                <div key={icon} className="w-10 h-10 flex items-center justify-center bg-white/5 rounded-full border border-white/10">
                  <i className={`${icon} text-emerald-400 text-base`} />
                </div>
              ))}
            </div>
          </div>

          {/* Right: Contact Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
            {/* Address */}
            <div>
              <h5 className="text-white/30 text-xs font-semibold tracking-[0.15em] uppercase mb-5">Location</h5>
              <ul className="flex flex-col gap-3">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-map-pin-2-line text-emerald-400 text-sm" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">Address</p>
                    <p className="text-white/50 text-sm">S. DABILJE 3</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-building-2-line text-emerald-400 text-sm" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">City</p>
                    <p className="text-white/50 text-sm">STRUMICA</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-hashtag text-emerald-400 text-sm" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">ZIP Code</p>
                    <p className="text-white/50 text-sm">2400</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-flag-2-line text-emerald-400 text-sm" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">Country</p>
                    <p className="text-white/50 text-sm">North Macedonia</p>
                  </div>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h5 className="text-white/30 text-xs font-semibold tracking-[0.15em] uppercase mb-5">Contact</h5>
              <ul className="flex flex-col gap-4">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-mail-line text-emerald-400 text-sm" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">Email</p>
                    <p className="text-white/50 text-sm">info@ideadoo.com</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                    <i className="ri-phone-line text-emerald-400 text-sm" />
                  </div>
                  <div>
                    <p className="text-white text-sm font-medium">Phone</p>
                    <p className="text-white/50 text-sm">+1 6402092200</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-white/30 text-sm">
            &copy; {new Date().getFullYear()} IDEA D.O.O. All rights reserved.
          </p>
          <p className="text-white/20 text-xs">
            iOS App Development &bull; VPN &bull; Cleaner &bull; North Macedonia
          </p>
        </div>
      </div>
    </section>
  );
}
